import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

const initializedWrappers = new WeakSet();

const initIntegrationsContentSwiper = (scope = document) => {
  const wrappers = scope.matches?.('.integrations-content-swiper-wr')
    ? [scope]
    : Array.from(scope.querySelectorAll('.integrations-content-swiper-wr'));

  wrappers.forEach((wrapper) => {
    if (initializedWrappers.has(wrapper)) {
      return;
    }

    const swiperEl = wrapper.querySelector('.swiper');

    if (!swiperEl) {
      return;
    }

    const nextEl = wrapper.querySelector('.swiper-button-next');
    const prevEl = wrapper.querySelector('.swiper-button-prev');

    initializedWrappers.add(wrapper);

    const swiperOptions = {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    };

    if (prevEl && nextEl) {
      swiperOptions.navigation = {
        prevEl,
        nextEl,
      };
    }

    swiperOnResize('(max-width: 1023px)', swiperEl, swiperOptions);
  });
};

initIntegrationsContentSwiper();
window.initIntegrationsContentSwiper = initIntegrationsContentSwiper;
